import React, { useState } from 'react';
import StaticPage from '../PageBuilder/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './FAQsPage.module.css'; // Adjust the import path as necessary

const faqs = [
  {
    title: "How does it work?",
    description: `
      <ul>
        <li>Download the app for free by searching Young Loved on the Apple Store or Google Play Store</li>
        <li>Register in a quick minute by answering a few questions</li>
        <li>From there you can either browse our catalogue of preloved gems, purchase items you’re interested in or start listing items to sell</li>
      </ul>
      <p>You get to declutter your home, make some cash, save money, and reduce your impact on our planet at the same time. It’s a win-win.</p>
    `,
  },
  {
    title: "How do I sign up?",
    description: `
      <p>It’s as simple as:</p>
      <ol>
        <li>Click 'Create Account' when prompted on the App OR using your Google account.</li>
        <li>Complete your profile by answering a few questions so we can best cater to you. You can save your responses and/or edit them under your account management page at a later date.</li>
        <li>Upload a profile picture and short bio to connect with like-minded peers (optional, but recommended!)</li>
      </ol>
      <p>Then you’re officially part of the Young Loved fam! From there you can browse the platform, use various filters or specific searches, list items to sell, follow and message other community members, and wishlist favourite items to keep an eye on.</p>
      <p>You can manage information under your profile page in the app at any time.</p>
    `,
  },
  {
    title: "How to sell?",
    description: `
      <strong>How to publish a listing</strong>
      <ul>
        <li>Click the ‘+’ button in the middle of the homepage on the app</li>
        <li>Follow the steps to publish a listing:
          <ul>
            <li><strong>Step 1:</strong> Take a moment to set up and verify your Stripe Connect profile via our third-party payments provider, Stripe. This allows your payment details to be securely stored with Stripe so you can get paid (cha-ching!)</li>
            <li><strong>Step 2:</strong> Add photos – at least 3, detailing any signs of wear & tear if applicable</li>
            <li><strong>Step 3:</strong> Fill in basic information for your listing (title, category, price, condition..)</li>
            <li><strong>Step 4:</strong> Add some detail to your listing (size, colour, material)</li>
          </ul>
        </li>
      </ul>
      <p>You can manage your payment method/bank account details under your account management page.</p>

      <br><br>
      <strong>Photo tips</strong>
      <ul>
        <li>Wash and iron or steam clothes before taking photos – you want to showcase them in their best light</li>
        <li>Take photos against a plain white/light background whenever possible – it allows the clothes/items to take centre stage</li>
        <li>Capture clothes/items from different angles</li>
        <li>Any defects or signs of wear and tear should be clearly captured</li>
        <li>Please don’t include any faces of children when listing items</li>
      </ul>

      <p><em>NB: Young Loved may remove photos at our discretion if they are non-compliant.</em></p>

      <br><br>
      <strong>Pricing tips</strong>
      <ul>
        <li>A general rule of thumb is 50% of the RRP or what you originally purchased the item for; however, it’s important to take into consideration:
          <ul style="margin-left: 20px;">
            <li>how old an item is</li>
            <li>what season it’s from</li>
            <li>the current condition</li>
            <li>amount of wear and tear</li>
            <li>how well it’s been cared for</li>
          </ul>
        </li>
      </ul>
      
      <br><br>
      <strong>Creating bundles</strong>
      <ul>
        <li>If you want to sell a set of items together instead of individually (for example, 3 bodysuits), you can opt to bundle the items into one listing.</li>
        <li>To do this simply select ‘SET’ under categories and create the listing in the same way, taking pictures of the items individually and as a set.</li>
        <li>Be sure to title the listing ‘SET of xxx’.</li>
        <li>A buyer may want to purchase multiple items from you; in which case they might ask you to create a set for them.</li>
        <li>You will have to close individual listings (see: how to close a listing) and create a new listing for the set of items.</li>
      </ul>

      <br><br>
      <strong>What items can I sell?</strong>
      <span class="small-break"></span>
      <p>For Maternity</p>
      <ul>
        <li>Clothes</li>
        <li>Maternity essentials (pumps, pregnancy pillows, etc.) please keep hygiene in mind and only list appropriate items. If buying or selling breast pumps, we strongly recommend buying/selling the model only, and investing in NEW breast shields, tubing, collection bottles and valves.</li>
        <li>Maternity & parenting books</li>
      </ul>
      <span class="small-break"></span>
      <p>For Kids</p>
      <ul>
        <li>Clothing (small baby – 14 yrs)</li>
        <li>Shoes</li>
        <li>Accessories</li>
        <li>Toys</li>
        <li>Books</li>
        <li>Equipment & furniture</li>
      </ul>

      <br><br>
      <strong>How to edit a listing</strong>
      <p>To edit details of a listing, go to your profile > my listings, click on the listing and edit the fields you want.</p>

      <br><br>
      <strong>How to close a listing</strong>
      <p>If you change your mind about a listing, follow these steps to close it:</p>
      <ul>
        <li>Go to your profile page</li>
        <li>Click on my listings</li>
        <li>Click on the ‘open’ button under the images – which will subsequently change to ‘close’</li>
      </ul>
      <p>Once ‘the listing is closed’ appears at the top of the page, the listing will no longer be seen by others or appear in searches.</p>
      <style>
         .small-break {
          display: block;
          height: 5px; /* Adjust this value for less/more space */
          }
      </style>
   `,
  },
  {
    title: "Consignment and Donations",
    description: `
       <strong>Consignment</strong>
       <p>We totally get it—sometimes there just aren’t enough hours in the day.
       We’re here to take the load off you if you want to declutter in a sustainable way but can’t seem to find the time. Lean on us—contact us today <strong>via the app</strong> or email us at <a href="mailto:mailto:hello@youngloved.com">hello@youngloved.com</a>.</p>

       <p>Please refer to <strong>the nitty gritty</strong> (below) to make sure the items you want to sell with us comply with our requirements.</p>

       <ul>
        <li>To get started, click on the ‘Consignment’ button at the bottom of the app’s homepage, or DM us on Instagram, or send us an email at <a href="mailto:mailto:hello@youngloved.com">hello@youngloved.com</a></li>
        <li>Include photos of the items you want us to sell for you and let us know what category/categories they fall under. (You can batch items for photos if there are a few). Note: Items should be washed and in sellable condition - <strong>no noticeable wear, tear or stains</strong> are accepted for consignment items.</li>
        <li>Ship them to us, making sure you include your contact details, and we’ll take care of the rest! Note: depending on postcode within London we may be able to personally pick up your items.</li>
        <li>We will spruce, steam, photograph and list your items on the app. We’ll also show them some love on socials.</li>
        <li>When items sell, we will package and send your items to their next home.</li>
        <li>Once an item sells, you pocket 65% of the sale and we take a 35% fee.</li>
        <li>Items are listed on consignment for 4 months. If your items haven’t sold after that period, we’ll contact you and you can either have them returned or we can donate them to charity - you decide.</li>
        <li><strong>The Nitty Gritty ‍</strong></li>
          <ul style="margin-left: 20px;">
            <li>Items must be in <strong>sellable condition</strong> i.e. no rips or tears (unless they are designed in that way), stains or broken - they should be in ‘good as new’ or ‘very good’ condition</li>
            <li><strong>We accept</strong> designer, contemporary and high street brands for both <strong>kids & maternity items.</strong></li>
            <li><strong>We do not accept</strong> ultra fast fashion brands, supermarket brands, underwear or pyjamas.</li>
            <li>We accept clothing sizes small baby - 14 years old</li>
            <li>amount of wear and tear</li>
            <li>We accept all kids shoe sizes.</li>
          </ul>
        </li>
      </ul>

      <br><br>
      <strong>Donations</strong>
      <p>Declutter, reduce your impact, live a more circular and sustainable lifestyle - and the profits go to charity. Whats not to love?</p>

      <ul>
        <li>Items must be in sellable condition. That means; no rips or tears (unless it’s part of the design), stains or broken in any way.</li>
        <li>Clothing items should be ‘good as new’ or ‘very good’ condition - just think would you want your kids wearing it?</li>
        <li>Books - should be intact without any ‘extra illustrations’ inside!</li>
        <li>Toys - should be cleaned with all its features present and intact.</li>
        <li>Equipment - should be thoroughly cleaned/sanitised. We can put you in touch with good buggy cleaners - just get in touch with us.</li>
        <li>We accept designer, contemporary and high street brands for both kids & maternity items Clothing sizes small baby - 14 years old or any women’s/maternity sizes.</li>
        <li>All kids shoe sizes welcome.</li>
        <li>No ultra fast fashion, underwear or pyjamas accepted.</li>
      </ul>
      <strong>If you have any questions just give us a shout!</strong>
    `,
  },
  {
    title: "Shipping",
    description: `
      <ul>
        <li>Once an item of yours has been purchased, you will be notified via the app and email.</li>
        <li>You should package your item(s) up appropriately and securely (see: packaging) before shipping, making sure all previous labels are removed or well covered, and add the buyer’s shipping details correctly on the box.</li>
        <li>There are different delivery services to use within the UK. We provide pricing guidelines for Royal Mail, EVRI and DPD in the App, but you can use any service of your choice.</li>
        <li>We recommended using a tracked service for your peace of mind, especially for more expensive items, and informing your buyer of the tracking number.</li>
        <li>Please ship your item(s) out within 7 days of someone purchasing them. If, for whatever reason, you are not able to ship within a week, please message the buyer and let them know.</li>
      </ul>
      <br><br>
      <strong>Meeting in person</strong>
      <ul>
        <li>If you choose to meet in person to complete a purchase, please do so with security in mind. We recommend meeting in daylight, in public spaces with others around.</li>
      </ul>
      <br><br>
      <strong>Packaging</strong>
      <p>Packing your item(s) in sturdy packaging is vital in making sure it arrives to buyers in good condition.</p>
      <ul>
        <li>Try to pack items in cardboard boxes where possible.</li>
        <li>If re-using packaging (recommended!), make sure all previous shipping labels are removed or properly covered.</li>
        <li>Please be sure to adhere to the packaging dimensions of your chosen shipping method.</li>
      </ul>
    `,
  },
  {
    title: "Payment and fees",
    description: `
      <ul>
        <li>All payments are processed securely through our payment partner, Stripe</li>
        <li>Please note that, at their discretion, Stripe may request additional information and/or documentation to verify your bank account details if necessary.</li>
        <li>Account information is NOT stored with Young Loved in any capacity - it is for Stripe's use only so you can get paid directly once an item has sold. ‍‍</li>
      </ul>
      <br><br>
      <strong>Fees</strong>
      <p>You can <strong>BUY & SELL FOR FREE</strong> on Young Loved - our platform currently takes no commission. So Sellers take home all that they make from a sale minus a small fee from Stripe for payment processing, which is 2.9% + 30p. Accepted payment methods are Visa, Mastercard, AMEX, Apple Pay and Google Pay.</p>
    `,
  },
  {
    title: "How to buy",
    description: `
      <ul>
        <li>Browse our category of preloved goods. Use the filters to search for more specific items.</li>
        <li>Simply click ‘buy now’ on an item to purchase. You will need to check out items separately if purchasing several items.</li>
        <li>You will be prompted to check if your shipping and billing details are correct before checking out.</li>
        <li>If you want to buy multiple items from one seller, you might want to ask them to create a set of items for you, so you can save on shipping costs.</li>
      </ul>
      <br><br>
      <strong>Messaging</strong>
      <ul>
        <li>If you have any questions about an item, you can message the seller directly using the messaging function within the app.</li>
        <li>Click on ‘message seller’ under ‘seller profile’ on a listing</li>
        <li>You will be notified about new messages via notifications and via email</li>
      </ul>
       <br><br>
      <strong>Returns</strong>
      <p>At this time we do not accept returns.</p>
      <p>If you would like more information on specific items, please be sure to message sellers (using the messaging function in our app) before making a purchase.</p>
    `,
  },
  {
    title: "Contact us",
    description: `
    <p>We’d love to hear from you!</p>
    <p>If you have questions or want to drop us a line with feedback, please reach out to us on: <a href="mailto:mailto:hello@youngloved.com">hello@youngloved.com</a>. You can also contact us directly via the app under account management > settings > report problem/app suggestion</p>
    <p>For collaborations and partnerships please contact us on: <a href="mailto:mailto:hello@youngloved.com">hello@youngloved.com</a></p>
     `,
   },
];

const FAQsPage = () => {
  return (
    <div className={css.pageWrapper}>
      <div className={css.topbar}>
        <TopbarContainer />
      </div>
      <StaticPage
        className={css.root}
        title="FAQs"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'FAQPage',
          description: 'Frequently Asked Questions about Young Loved',
          name: 'FAQs Page',
        }}
      >
        <div className={css.content}>
          <h1 className={css.title}>FAQS</h1>
          <div className={css.faqsContainer}>
            {faqs.map((faq, index) => (
              <FAQItem key={index} title={faq.title} description={faq.description} />
            ))}
          </div>
        </div>
      </StaticPage>
      <div className={css.footer}>
        <FooterContainer />
      </div>
    </div>
  );
};

const FAQItem = ({ title, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFAQ = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`${css.faqItem} ${isOpen ? css.open : ''}`}>
      <div className={css.faqTitle} onClick={toggleFAQ}>
        <div className={css.iconContainer}>
          <div className={css.circle}></div> {/* White circle */}
          <img
            src={
              isOpen
                ? '/static/images/minus-icon.svg'
                : '/static/images/plus-icon.svg'
            }
            alt={isOpen ? 'Collapse' : 'Expand'}
            className={`${css.icon} ${isOpen ? css.rotate : ''}`}
          />
        </div>
        <h1 className={css.faqTitleText}>{title}</h1>
      </div>
      
      {/* Render description with line breaks */}
      <div 
        className={`${css.faqDescription} ${isOpen ? css.open : ''}`}
        dangerouslySetInnerHTML={{ __html: description }} 
        onClick={toggleFAQ}
      />
    </div>
  );
};

export default FAQsPage;
